<mat-form-field [appearance]="appearance" fxFlex>
  <mat-label>{{ 'EQUIPMENTS_TYPES_SELECT.TITLE' | translate }}</mat-label>
  <mat-select
    [(formControl)]="selectedValue"
    [disabled]="disabled"
    [compareWith]="compareEquipmentType"
    [required]="required"
  >
    <mat-select-trigger>
      <span [ngClass]="{ 'archived-selected': selectedValue.value?.archived }">
        {{ selectedValue.value && selectedValue.value.name ? selectedValue.value.name : '' }}
      </span>
      <span
        *ngIf="selectedValue.value?.archived"
        class="archived-label"
        matTooltip="{{ 'EQUIPMENTS_TYPES_SELECT.WARNING' | translate }}"
      >
        {{ 'EQUIPMENTS_TYPES_SELECT.ARCHIVED' | translate }}
      </span>
    </mat-select-trigger>
    <mat-option *ngFor="let equipmentType of equipmentsTypes" [value]="equipmentType">
      <span [ngClass]="{ 'archived-selected': equipmentType.archived }">{{ equipmentType.name }}</span>
      <span
        *ngIf="equipmentType.archived"
        class="archived-label option"
        matTooltip="{{ 'EQUIPMENTS_TYPES_SELECT.WARNING' | translate }}"
      >
        {{ 'EQUIPMENTS_TYPES_SELECT.ARCHIVED' | translate }}
      </span>
    </mat-option>
  </mat-select>
  <mat-error>
    <span *ngIf="selectedValue.hasError('required')">
      {{ 'EQUIPMENTS_TYPES_SELECT.ERROR' | translate }}
    </span>
  </mat-error>
</mat-form-field>
